/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteResponseData,
  GetSiteResponseDataFromJSON,
  GetSiteResponseDataFromJSONTyped,
  GetSiteResponseDataToJSON
} from './GetSiteResponseData'

/**
 *
 * @export
 * @interface CopySiteResponse
 */
export interface CopySiteResponse {
  /**
   *
   * @type {number}
   * @memberof CopySiteResponse
   */
  status: number
  /**
   *
   * @type {GetSiteResponseData}
   * @memberof CopySiteResponse
   */
  data: GetSiteResponseData
}

export function CopySiteResponseFromJSON(json: any): CopySiteResponse {
  return CopySiteResponseFromJSONTyped(json, false)
}

export function CopySiteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopySiteResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: GetSiteResponseDataFromJSON(json['data'])
  }
}

export function CopySiteResponseToJSON(value?: CopySiteResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteResponseDataToJSON(value.data)
  }
}
